module.exports = __webpack_public_path__ + "static/img/10.3667574.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/10.png
// module id = PMei
// module chunks = 0